import * as React from 'react';
import { IIconProps } from '../../types';
import { SIMPLIFY_COLORS } from '../../../../constants/colors';

export const CrossSmall24: React.FC<IIconProps> = props => {
  const { color: _color } = props;

  const color = _color ? SIMPLIFY_COLORS[_color] : SIMPLIFY_COLORS.primary;

  return (
    // eslint-disable-next-line react/forbid-elements
    <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.17157 9.17157L10 12M12.8284 14.8284L10 12M10 12L12.8284 9.17157M10 12L7.17157 14.8284"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7099 8.29C13.617 8.19627 13.5064 8.12188 13.3845 8.07111C13.2627 8.02034 13.132 7.9942 12.9999 7.9942C12.8679 7.9942 12.7372 8.02034 12.6154 8.07111C12.4935 8.12188 12.3829 8.19627 12.2899 8.29L9.99994 10.59L7.70994 8.29C7.52164 8.1017 7.26624 7.99591 6.99994 7.99591C6.73364 7.99591 6.47824 8.1017 6.28994 8.29C6.10164 8.4783 5.99585 8.7337 5.99585 9C5.99585 9.2663 6.10164 9.5217 6.28994 9.71L8.58994 12L6.28994 14.29C6.19621 14.383 6.12182 14.4936 6.07105 14.6154C6.02028 14.7373 5.99414 14.868 5.99414 15C5.99414 15.132 6.02028 15.2627 6.07105 15.3846C6.12182 15.5064 6.19621 15.617 6.28994 15.71C6.3829 15.8037 6.4935 15.8781 6.61536 15.9289C6.73722 15.9797 6.86793 16.0058 6.99994 16.0058C7.13195 16.0058 7.26266 15.9797 7.38452 15.9289C7.50638 15.8781 7.61698 15.8037 7.70994 15.71L9.99994 13.41L12.2899 15.71C12.3829 15.8037 12.4935 15.8781 12.6154 15.9289C12.7372 15.9797 12.8679 16.0058 12.9999 16.0058C13.132 16.0058 13.2627 15.9797 13.3845 15.9289C13.5064 15.8781 13.617 15.8037 13.7099 15.71C13.8037 15.617 13.8781 15.5064 13.9288 15.3846C13.9796 15.2627 14.0057 15.132 14.0057 15C14.0057 14.868 13.9796 14.7373 13.9288 14.6154C13.8781 14.4936 13.8037 14.383 13.7099 14.29L11.4099 12L13.7099 9.71C13.8037 9.61704 13.8781 9.50644 13.9288 9.38458C13.9796 9.26272 14.0057 9.13201 14.0057 9C14.0057 8.86799 13.9796 8.73728 13.9288 8.61542C13.8781 8.49356 13.8037 8.38296 13.7099 8.29Z"
        fill={color}
      />
    </svg>
  );
};
